"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";
import { defaultAppShell } from "../constants/default-schema";
import type { AppShellSchema, HeaderTabsPageSchema, WorkflowSchema } from "../types/schema";

type SchemaStore = {
  appShell: AppShellSchema;
  workflows: Record<string, WorkflowSchema>;
  pages: Record<string, HeaderTabsPageSchema>;
  updateAppShell: (schema: AppShellSchema) => void;
  updateWorkflow: (id: string, schema: WorkflowSchema) => void;
  updatePage: (id: string, schema: HeaderTabsPageSchema) => void;
  resetToDefaults: () => void;
};

export const useSchemaStore = create<SchemaStore>()(
  persist(
    (set) => ({
      appShell: defaultAppShell,
      workflows: {},
      pages: {},
      updateAppShell: (schema) => set({ appShell: schema }),
      updateWorkflow: (id, schema) =>
        set((state) => ({
          workflows: { ...state.workflows, [id]: schema },
        })),
      updatePage: (id, schema) =>
        set((state) => ({
          pages: { ...state.pages, [id]: schema },
        })),
      resetToDefaults: () =>
        set({
          appShell: defaultAppShell,
          workflows: {},
          pages: {},
        }),
    }),
    {
      name: "schema-storage",
    }
  )
);
